export const phonePattern = /^\(\d{3}\)\s?\d{3}-\d{4}$/

export const phoneNumberExample = "(778) 994-4241"

export const phoneNumberValidationMessage = `Phone number must be in a valid format (e.g., ${phoneNumberExample})`

export const normalizePhoneNumber = (value?: string) => value?.replace(/\D/g, "").slice(0, 10) || ""

export const formatPhoneNumber = (value: string) => {
  const digits = normalizePhoneNumber(value)

  if (digits.length === 0) {
    return ""
  }

  if (digits.length <= 3) {
    return `(${digits}`
  }

  if (digits.length <= 6) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3)}`
  }

  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`
}
